module.exports = __webpack_public_path__ + "img/rspo.89af1bad.png";